export const ADMIN_ONLY = ["admin"];
export const PO_ONLY = ["po"];
export const ADMIN_AND_PO = ["admin", "po"];
